import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import VendorProfileBasicDetail from "components/VendorProfile/VendorProfileBasicDetail";
import { VendorProfileDetailContext } from "contexts/VendorProfileDetailContext";
import { useAppMeta, useAuth } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { Link, useParams, } from "react-router-dom";
import { useGetVendorProfileDetailQuery } from "store/services/vendorProfileApi";

import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import VendorProfileDetailTab from "components/VendorProfile/VendorProfileDetailTabs";



const VendorProfileDetailScreen = () => {

  const { id } = useParams();

  const breadcrumbs = [
    { title: "Vendor Profile", path: "/app/crm/vendor-profile/list" },
    { title: "Vendor Profile Detail" },
  ];

  const {
    data: vendorProfileDetail,
    isLoading: loadingVendorProfileDetail,
    error,
  } = useGetVendorProfileDetailQuery(id);

  const PageActions = () => {
    const { isSystemAdmin, isAccountAdmin } = useAuth();
    return (
      <>
        {(isSystemAdmin || isAccountAdmin) && (
          <Link to={`/app/crm/vendor-profile/${id}/edit`}>
            <Button variant="contained" startIcon={<EditOutlined />}>
              Edit
            </Button>
          </Link>)}
      </>
    )
  }

  useAppMeta("Vendor Profile Detail");

  return (
    <VendorProfileDetailContext.Provider
      value={{ vendorProfileDetail, loadingVendorProfileDetail }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingVendorProfileDetail}
        error={error}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        {!loadingVendorProfileDetail ? (
          <BreadcrumbLayout.Paper>
            <VendorProfileBasicDetail />
            <Divider />
            <VendorProfileDetailTab />
          </BreadcrumbLayout.Paper>
        ) : (
          <InfoGridSkeleton />
        )}
      </BreadcrumbLayout>
    </VendorProfileDetailContext.Provider>
  );
};

export default VendorProfileDetailScreen;
